module.exports = __webpack_public_path__ + "d1adafda6b69f60469fd676ae6e15f12.png";